/**
 * Polish
 * @type Object
 */
const pl = {
  btn: {
    about: 'O Programie',
    back: 'Wstecz',
    cancel: 'Anuluj',
    clear: 'Wyczyść',
    copy: 'Kopiuj',
    cut: 'Wytnij',
    delete: 'Usunąć',
    edit: 'Edytować',
    forward: 'Naprzód',
    folder: 'Nowy folder',
    file: 'Nowy plik',
    fullScreen: 'Pełny ekran',
    grid: 'Siatka',
    paste: 'Pasta',
    refresh: 'Odświeżać',
    submit: 'Zatwierdź',
    table: 'Tabela',
    upload: 'Przekazać plik',
    uploadSelect: 'Wybierz pliki',
    hidden: 'Ukryte pliki',
  },
  clipboard: {
    actionType: 'Rodzaj',
    copy: 'Kopiuj',
    cut: 'Skaleczenie',
    none: 'Nic nie zostało zaznaczone',
    title: 'Schowek',
  },
  contextMenu: {
    copy: 'Kopiuj',
    cut: 'Skaleczenie',
    delete: 'Usunąć',
    download: 'Pobieranie',
    info: 'Wybrany:',
    open: 'otwarty',
    paste: 'Pasta',
    properties: 'Nieruchomości',
    rename: 'Przemianować',
    select: 'Wybierz',
    view: 'Widok',
    zip: 'Zamek błyskawiczny',
    unzip: 'Rozsunąć suwak',
    edit: 'Edytować',
    audioPlay: 'Odtwórz',
    videoPlay: 'Odtwórz',
  },
  info: {
    directories: 'Katalogi',
    files: 'Pliki:',
    selected: 'Wybrany:',
    selectedSize: 'Rozmiar plików:',
    size: 'Rozmiar plików:',
  },
  manager: {
    table: {
      date: 'Data',
      folder: 'Folder',
      name: 'Nazwa',
      size: 'Rozmiar',
      type: 'Rodzaj',
    },
  },
  modal: {
    about: {
      developer: 'Deweloper',
      name: 'Menedżer plików',
      title: 'O',
      version: 'Wersja',
    },
    delete: {
      noSelected: 'Nic nie zostało zaznaczone!',
      title: 'Usunąć',
    },
    newFile: {
      fieldName: 'Nazwa pliku',
      fieldFeedback: 'Plik istnieje!',
      title: 'Utwórz nowy plik',
    },
    newFolder: {
      fieldName: 'Nazwa folderu',
      fieldFeedback: 'Katalog istnieje!',
      title: 'Stwórz nowy folder',
    },
    preview: {
      title: 'Zapowiedź',
    },
    properties: {
      disk: 'Dysk',
      modified: 'Zmodyfikowano',
      name: 'Nazwa',
      path: 'Ścieżka',
      size: 'Rozmiar',
      title: 'Nieruchomości',
      type: 'Rodzaj',
      url: 'URL',
      access: 'Dostęp',
      access_0: 'Brak dostępu',
      access_1: 'Tylko do odczytu',
      access_2: 'Czytaj i pisz',
    },
    rename: {
      directoryExist: 'Katalog istnieje',
      fieldName: 'Wpisz nową nazwę',
      fieldFeedback: 'Błędna nazwa',
      fileExist: 'Plik istnieje',
      title: 'Przemianować',
    },
    status: {
      noErrors: 'Bez błędów!',
      title: 'Status',
    },
    upload: {
      ifExist: 'Jeśli plik istnieje:',
      noSelected: 'Nie wybrano plików!',
      overwrite: 'Nadpisać!',
      selected: 'Wybrany:',
      size: 'Rozmiar:',
      skip: 'Pominąć',
      title: 'Prześlij pliki',
    },
    editor: {
      title: 'Redaktor',
    },
    audioPlayer: {
      title: 'Odtwarzacz muzyki',
    },
    videoPlayer: {
      title: 'Odtwarzacz wideo',
    },
    zip: {
      title: 'Utwórz archiwum',
      fieldName: 'Nazwa archiwum',
      fieldFeedback: 'Archiwum istnieje!',
    },
    unzip: {
      title: 'Rozpakuj archiwum',
      fieldName: 'Nazwa folderu',
      fieldRadioName: 'Wypakować do:',
      fieldRadio1: 'Do bieżącego folderu',
      fieldRadio2: 'W nowym folderze',
      fieldFeedback: 'Katalog istnieje!',
      warning: 'Uwaga! Jeśli nazwy pasują, pliki zostaną nadpisane!',
    },
    cropper: {
      title: 'Cropowanie',
      apply: 'Zastosować',
      reset: 'Resetowanie',
      save: 'Zapisać',
    },
  },
  notifications: {
    cutToClipboard: 'Wytnij do schowka!',
    copyToClipboard: 'Skopiowane do schowka!',
  },
  response: {
    noConfig: 'Nie znaleziono konfiguracji!',
    notFound: 'Nie znaleziono!',
    diskNotFound: 'Nie znaleziono dysku!',
    pathNotFound: 'Droga nie znaleziona!',
    diskSelected: 'Dysk wybrany!',
    // files
    fileExist: 'Plik już istnieje!',
    fileCreated: 'Plik utworzony!',
    fileUpdated: 'Plik zaktualizowany!',
    fileNotFound: 'Nie znaleziono pliku!',
    // directories
    dirExist: 'Katalog już istnieje!',
    dirCreated: 'Katalog utworzony!',
    dirNotFound: 'Nie znaleziono katalogu',
    // actions
    uploaded: 'Wszystkie przesłane pliki!',
    notAllUploaded: 'Niektóre pliki nie zostały przesłane!',
    delNotFound: 'Niektóre pozycje nie zostały znalezione!',
    deleted: 'Usunięto!',
    renamed: 'Zmieniona nazwa!',
    copied: 'Skopiowano pomyślnie!',
    // zip
    zipError: 'Błąd podczas tworzenia archiwum!',
    // acl
    aclError: 'Brak dostępu!',
  },
};

export default pl;
